import { AVATAR_SIZE } from 'src/utils/constants';
import { PostProps } from 'src/hook/usePosts';
import { PropsCreatePost } from 'src/components/InputMarkdown/types';
import { BlockCommentsMutationProps } from 'src/pages/CommunityDetails/Posts/blockCommentsModal/hooks/useBlockCommentsMutation/useBlockCommentsMutation.types';
import api from '../apiSparkle';

import { POSTS_PER_PAGE, PostsEndpoints } from './constants';
import {
  PostParams,
  PostResponse,
  GetSchedulePostParams,
  ResponseGetSchedulePost,
  GetPostDetailsParams,
  PinPostParms
} from './types';

class PostsService {
  static async getPostDetails({ id, avatarSize = AVATAR_SIZE }: GetPostDetailsParams) {
    const params = {
      avatarDimensions: `${avatarSize}x${avatarSize}`
    };

    const { data } = await api.get<PostProps>(PostsEndpoints.getPostDetails(id), {
      params
    });

    return data;
  }

  static async getPostDetailsPublic({ id, avatarSize = AVATAR_SIZE }: GetPostDetailsParams) {
    const params = {
      avatarDimensions: `${avatarSize}x${avatarSize}`
    };

    const { data } = await api.get<PostProps>(PostsEndpoints.getPostDetailsPublic(id), {
      params
    });

    return data;
  }

  static async getScheduledPosts({
    avatarSize,
    id,
    filters,
    page = 0,
    rows = POSTS_PER_PAGE
  }: PostParams) {
    const params = new URLSearchParams(
      JSON.parse(
        JSON.stringify({
          page,
          rows,
          avatarDimensions: `${avatarSize}x${avatarSize}`,
          pubDateOrder: filters?.pubDateOrder,
          filterReadUnread: filters?.filterReadUnread,
          myNews: filters?.myNews
        })
      )
    );

    const { data } = await api.get<PostResponse>(PostsEndpoints.getSchedulePosts(id), {
      params
    });

    return data;
  }

  static async getSchedulePost({ postId, communityId }: GetSchedulePostParams) {
    const params = { communityId };

    const { data } = await api.get<ResponseGetSchedulePost>(
      PostsEndpoints.getSchedulePost(postId),
      {
        params
      }
    );

    return data;
  }

  static async postPinPost({ communityId, postId }: PinPostParms) {
    const collection = `collection=${communityId}`;

    const { data } = await api.post<void>(PostsEndpoints.postPinPost(postId), collection, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'data-urlencode': collection
      }
    });

    return data;
  }

  static async blockCommentsPost({ postId, isCommentsEnabled }: BlockCommentsMutationProps): Promise<number> {
    const { status } = await api.patch<void>(PostsEndpoints.blockCommentsPost(postId), { commentsEnabled: !isCommentsEnabled })

    return status;
  }

  static async postUnpinPost({ communityId, postId }: PinPostParms) {
    const collection = `collection=${communityId}`;

    const { data } = await api.post<void>(PostsEndpoints.postUnpinPost(postId), collection, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'data-urlencode': collection
      }
    });

    return data;
  }

  static async createPublication(publication: PropsCreatePost) {
    const res = await api.post<string>(PostsEndpoints.postCreatePublication(), publication);

    const postLocation = res.headers.location.split('/');
    const postId = postLocation[postLocation.length - 1];

    return postId;
  }
}

export default PostsService;
